import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import homepage from '@/views/homepage'
import home from '@/views/home'
import ApartmentManagement from '@/views/ApartmentManagement'
import RoomManagement from '@/views/RoomManagement'
import JanitorManagement from '@/views/JanitorManagement'
import DeviceManagement from '@/views/DeviceManagement'
import TenantManagement from '@/views/TenantManagement'
import UserManagement from '@/views/UserManagement'
import UnlockRecord from '@/views/UnlockRecord'
import OperationRecord from '@/views/OperationRecord'
import CheckInRecord from '@/views/CheckInRecord'
import ProductManagement from '@/views/ProductManagement'
import FirmwareManagement from '@/views/FirmwareManagement'
import AppRoleList from '@/views/AppRoleList'
import OtaBinManagement from '@/views/OtaBinManagement'
import OtaTaskManagement from '@/views/OtaTaskManagement'

Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: '/',
      name: '',
      component: login,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/homepage',
      name: 'homepage',
      component: homepage,
      redirect: "/homepage/ApartmentManagement",
      children: [
        {
          path: '/homepage/home',
          name: 'homepage/home',
          component: home,
        },
        {
          path: '/homepage/ApartmentManagement',
          name: 'homepage/ApartmentManagement',
          component: ApartmentManagement,
        },
        {
          path: '/homepage/RoomManagement',
          name: 'homepage/RoomManagement',
          component: RoomManagement,
        },
        {
          path: '/homepage/JanitorManagement',
          name: 'homepage/JanitorManagement',
          component: JanitorManagement,
        },
        {
          path: '/homepage/DeviceManagement',
          name: 'homepage/DeviceManagement',
          component: DeviceManagement,
        },
        {
          path: '/homepage/TenantManagement',
          name: 'homepage/TenantManagement',
          component: TenantManagement,
        },
        {
          path: '/homepage/UserManagement',
          name: 'homepage/UserManagement',
          component: UserManagement,
        },
        {
          path: '/homepage/UnlockRecord',
          name: 'homepage/UnlockRecord',
          component: UnlockRecord,
        },
        {
          path: '/homepage/OperationRecord',
          name: 'homepage/OperationRecord',
          component: OperationRecord,
        },
        {
          path: '/homepage/CheckInRecord',
          name: 'homepage/CheckInRecord',
          component: CheckInRecord,
        },
        {
          path: '/homepage/ProductManagement',
          name: 'homepage/ProductManagement',
          component: ProductManagement,
        },
        {
          path: '/homepage/FirmwareManagement',
          name: 'homepage/FirmwareManagement',
          component: FirmwareManagement,
        },
        {
          path: '/homepage/AppRoleList',
          name: 'homepage/AppRoleList',
          component: AppRoleList,
        },
        {
          path: '/homepage/OtaBinManagement',
          name: 'homepage/OtaBinManagement',
          component: OtaBinManagement,
        },
        {
          path: '/homepage/OtaTaskManagement',
          name: 'homepage/OtaTaskManagement',
          component: OtaTaskManagement,
        },

      ]
    }
  ]

});

/*在跳转之前执行*/
router.beforeEach((to, from, next) => {

  next()

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js